import React, { useState } from "react";
import { Modal, Button, Select } from "antd";
import axios from "axios";
import "antd/dist/antd.css";

const { Option } = Select;

export const RemoveUserModal = ({ version_id, usersInVersion, token, onUpdate }) => {
  const [visible, setVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    axios
      .post(
        process.env.REACT_APP_API + "/api/mobile_app/removeuser",
        { version_id, user_id: selectedUser },
        {
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        console.log(response);
        onUpdate();
      })
      .catch(error => console.error(error));

    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleChange = value => {
    setSelectedUser(value);
  };

  return (
    <div>
      <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={showModal}>
        Supprimer un utilisateur
      </Button>
      <Modal title="Suppression d'un utilisateur" visible={visible} onOk={handleOk} onCancel={handleCancel}>
        <Select
          showSearch
          allowClear={true}
          style={{ width: "90%" }}
          placeholder="Choisir l'utilisateur à supprimer de la version mobile"
          optionFilterProp="children"
          onChange={handleChange}
        >
          {usersInVersion.map(user => (
            <Option key={user.userId} value={user.userId}>
              {user.email}
            </Option>
          ))}
        </Select>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/RemoveUser.modal.js